import './index.scss';

import React, { useState } from 'react';
import { BsCart, BsFillCaretDownFill, BsGear, BsList } from 'react-icons/bs';
import { Link, NavLink } from 'react-router-dom';

import { ReactComponent as ApprovedTransIcon } from '../../assets/Images/approved_transaction_icon.svg';
import { ReactComponent as AuditIcon } from '../../assets/Images/audit_icon.svg';
import { ReactComponent as CustomerIcon } from '../../assets/Images/customers_icon.svg';
import { ReactComponent as DashboardIcon } from '../../assets/Images/dashboard.svg';
import { ReactComponent as GasCylinderIcon } from '../../assets/Images/gas_cylinder.svg';
import homefortLogo from '../../assets/Images/Gasflow.svg';
import { ReactComponent as WalletIcon } from '../../assets/Images/icon_wallet_.svg';
import { ReactComponent as LogOutIcon } from '../../assets/Images/Logout.svg';
import { ReactComponent as PricingIcon } from '../../assets/Images/pricing_icon.svg';
import { ReactComponent as RepaymentIcon } from '../../assets/Images/repayment_record_icon.svg';
import { ReactComponent as DailySalesIcon } from '../../assets/Images/sales_record_icon.svg';
import { ReactComponent as StaffIcon } from '../../assets/Images/staff.svg';
import { ReactComponent as UnApprovedTransIcon } from '../../assets/Images/unaprroved_transaction_icon.svg';
import useActions from '../../hooks/useActions';

function Sidebar() {
  const { setHeader, signOut } = useActions();
  const [transDropdown, setTransDropdown] = useState(false);

  const makeActive = (event) => {
    event.preventDefault();
    const sidebar = document.querySelector('#sidebar');
    // const container = document.querySelector('.my-container');

    sidebar?.classList.toggle('sidebar_on');
    // container?.classList.toggle("active-cont");
  };

  const toggleDropDown = () => {
    // const dropdownBtn = document.querySelector('.dropdown-btn');
    const dropdownCaret = document.querySelector('.dropdown_caret');
    const dropdownContent = document.querySelector('.dropdown-container');
    // dropdownBtn.classList.toggle('dp_active');
    dropdownCaret.classList.toggle('caret_active');
    if (dropdownContent.style.display === 'block') {
      dropdownContent.style.display = 'none';
    } else {
      dropdownContent.style.display = 'block';
    }
  };

  return (
    <>
      <nav
        className="navbar navbar-expand d-flex flex-column align-items-center h-100 sidebar_navbar"
        id="sidebar">
        <Link to="/" className="navbar-brand text-center d-block">
          <img src={homefortLogo} alt="logo" />
        </Link>
        <div className="d-flex flex-column justify-content-between h-100 mt-4">
          <ul className="navbar-nav d-flex flex-column w-100 h-100 sidebar_navbar_nav">
            <li
              onClick={() => setHeader('Dashboard')}
              role="presentation"
              onKeyDown={() => {}}
              className="nav-item w-100">
              <NavLink
                activeClassName="sd_active"
                to="/"
                exact
                className="nav-link sidebar_navbar_navlink">
                <DashboardIcon />
                <span className="ms-2">Dashboard</span>
              </NavLink>
            </li>
            <li className="nav-item w-100">
              <div
                onClick={() => setTransDropdown((value) => !value)}
                role="presentation"
                className="sidebar_navbar_navlink mb-2">
                <UnApprovedTransIcon className="me-2" />
                Transactions
                <BsFillCaretDownFill
                  className="ms-2"
                  style={{ transform: transDropdown ? 'rotate(180deg)' : '' }}
                />
              </div>
              <div className="ps-4" style={{ display: transDropdown ? 'block' : 'none' }}>
                <NavLink
                  onClick={() => setHeader('Approved Transactions')}
                  activeClassName="sd_active"
                  to="/approved"
                  className="nav-link sidebar_navbar_navlink">
                  <ApprovedTransIcon />
                  <span className="ms-2">Approved</span>
                </NavLink>
                <NavLink
                  onClick={() => setHeader('Unapproved Transactions')}
                  activeClassName="sd_active"
                  to="/unapproved"
                  className="nav-link sidebar_navbar_navlink">
                  <UnApprovedTransIcon />
                  <span className="ms-2">Unapproved</span>
                </NavLink>
              </div>
            </li>
            {/* <li */}
            {/*  role="presentation" */}
            {/*  onKeyDown={() => {}} */}
            {/*  onClick={() => setHeader('Approved Transactions')} */}
            {/*  className="nav-item w-100"> */}
            {/*  <NavLink */}
            {/*    activeClassName="sd_active" */}
            {/*    to="/approved" */}
            {/*    className="nav-link sidebar_navbar_navlink"> */}
            {/*    <ApprovedTransIcon /> */}
            {/*    <span className="ms-2">Approved Transactions</span> */}
            {/*  </NavLink> */}
            {/* </li> */}
            {/* <li */}
            {/*  role="presentation" */}
            {/*  onKeyDown={() => {}} */}
            {/*  onClick={() => setHeader('Unapproved Transactions')} */}
            {/*  className="nav-item w-100"> */}
            {/*  <NavLink */}
            {/*    activeClassName="sd_active" */}
            {/*    to="/unapproved" */}
            {/*    className="nav-link sidebar_navbar_navlink"> */}
            {/*    <UnApprovedTransIcon /> */}
            {/*    <span className="ms-2">Unapproved Transactions</span> */}
            {/*  </NavLink> */}
            {/* </li> */}
            <li
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => setHeader('Customers')}
              className="nav-item w-100">
              <NavLink
                activeClassName="sd_active"
                to="/customers"
                className="nav-link sidebar_navbar_navlink">
                <CustomerIcon />
                <span className="ms-2">Customers</span>
              </NavLink>
            </li>
            <li
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => setHeader('Staffs')}
              className="nav-item w-100">
              <NavLink
                activeClassName="sd_active"
                to="/staffs"
                className="nav-link sidebar_navbar_navlink">
                <StaffIcon />
                <span className="ms-2">Staffs</span>
              </NavLink>
            </li>
            <li
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => setHeader('Daily Sales Record')}
              className="nav-item w-100">
              <NavLink
                activeClassName="sd_active"
                to="/dailysalesrecord"
                className="nav-link sidebar_navbar_navlink">
                <DailySalesIcon />
                <span className="ms-2">Daily Sales Record</span>
              </NavLink>
            </li>
            <li
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => setHeader('Audit')}
              className="nav-item w-100">
              <NavLink
                activeClassName="sd_active"
                to="/audit"
                className="nav-link sidebar_navbar_navlink">
                <AuditIcon />
                <span className="ms-2">Audit</span>
              </NavLink>
            </li>
            <li
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => setHeader('Debt Repayment Record')}
              className="nav-item w-100">
              <NavLink
                activeClassName="sd_active"
                to="/debt_repayment_record"
                className="nav-link sidebar_navbar_navlink">
                <RepaymentIcon />
                <span className="ms-2">Debt Repayment Record</span>
              </NavLink>
            </li>
            <li
              role="presentation"
              onKeyDown={() => {}}
              onClick={() => setHeader('Wallet Payment Record')}
              className="nav-item w-100">
              <NavLink
                activeClassName="sd_active"
                to="/wallet_payment_record"
                className="nav-link sidebar_navbar_navlink">
                <WalletIcon />
                <span className="ms-2">Wallet Payment Record</span>
              </NavLink>
            </li>
            <li className="nav-item w-100">
              <div
                onClick={toggleDropDown}
                role="presentation"
                className="dropdown-btn sidebar_navbar_navlink">
                <BsGear className="me-2" />
                Settings
                <BsFillCaretDownFill className="ms-2 dropdown_caret" />
              </div>
              <div className="dropdown-container">
                <NavLink
                  onClick={() => setHeader('Pricing')}
                  activeClassName="sd_active"
                  to="/pricing"
                  className="nav-link">
                  <BsCart />
                  <span className="ms-3">Pricing</span>
                </NavLink>
                <NavLink
                  onClick={() => setHeader('Price Approval')}
                  activeClassName="sd_active"
                  to="/approval"
                  className="nav-link">
                  <PricingIcon />
                  <span className="ms-3">Price Approval</span>
                </NavLink>
                <button type="button" onClick={() => signOut()} className="p-2 btn text-danger">
                  <LogOutIcon className="me-2" />
                  Log Out
                </button>
              </div>
            </li>
          </ul>
          <div className="py-1 text-center">
            {/* <hr /> */}
            <NavLink
              onClick={() => setHeader('Create CIN')}
              activeClassName="sd_active"
              to="/createcin"
              className="nav-link h-100 py-3 border-1 border-top border-dark">
              <GasCylinderIcon className="me-2" />
              <span className="ms-3">Create CIN</span>
            </NavLink>
          </div>
        </div>
      </nav>
      <button
        type="button"
        onClick={makeActive}
        className="toggle-button d-md-none d-flex justify-content-center align-items-center">
        <BsList />
      </button>
    </>
  );
}

export default Sidebar;
